import React from 'react';
import { themeOptions } from 'theme';
import styled from 'styled-components';

const TagContainer = styled.span<{
  $color?: string;
  $margin?: string;
  $padding?: string;
  $fontWeight?: string | number;
}>`
  padding: 0.25rem 0.625rem;
  border-radius: 1rem;
  font-size: 0.875rem;
  line-height: 1.36;
  ${(props) => props.$margin && `margin: ${props.$margin}`};
  ${(props) => props.$padding && `padding: ${props.$padding}`};
  ${(props) => props.$fontWeight && `font-weight: ${props.$fontWeight}`};

  ${(props) =>
    props.$color &&
    `
    ${!props.$fontWeight && 'font-weight: 500'};
    background-color: ${getBackgroundColor(props.$color)};
    color: ${props.$color};
  `}}
`;

const TagWrapper = styled.span<{ $color?: string }>`
  filter: brightness(40%);
  white-space: nowrap;
`;

const getBackgroundColor = (color: string): string => {
  const colors = themeOptions.colors;

  if (color === colors.success900) return colors.success100;
  if (color === colors.error900) return colors.error200;
  if (color === colors.info900) return colors.info300;
  if (color === colors.neutral600) return colors.neutral300;

  return `${color}99`;
};

interface TagInterface {
  text: string;
  color?: string;
  margin?: string;
  padding?: string;
  fontWeight?: string | number;
}

export const Tag = ({ text, color, margin, padding, fontWeight }: TagInterface) => (
  <TagContainer $color={color} $margin={margin} $padding={padding} $fontWeight={fontWeight}>
    <TagWrapper $color={color}>{text}</TagWrapper>
  </TagContainer>
);
